import { Box, IconButton, Tooltip, Typography } from "@mui/material"
import MaterialReactTable from "material-react-table"
import React, { useMemo, useState } from "react"
//Import Material React Table Translations
import { MRT_Localization_ES } from "material-react-table/locales/es"
//Icons Imports
import VisibilityIcon from "@mui/icons-material/Visibility"
import { ThemeProvider, darken } from "@mui/material"

const TablaObservacionesPGD = ({
    columnas,
    lineas,
    titulo,
    handleOpen,
    acciones = false,
}) => {
    const columns = useMemo(() => columnas, [lineas])
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10,
    })


    const openModal = (row) => {
        var id = row.getValue("id")
        handleOpen(id, row.original)
    }

    return (

        <>
            <ThemeProvider>
                <MaterialReactTable
                    muiTablePaginationProps={{
                        rowsPerPageOptions: [5, 10],
                        showFirstLastPageButtons: false,
                    }}
                    onPaginationChange={setPagination}
                    state={{ pagination }}
                    columns={columns}
                    data={lineas}
                    muiTablePaperProps={{
                        sx: (theme) => ({
                            borderRadius: '0.55rem',
                            border: darken(theme.palette.background.default, 0.1),
                            bgcolor: darken(theme.palette.primary.dark, 0.1),
                            maxWidth: '100vw',
                            m: 'auto',
                        }),
                    }}
                    enableFullScreenToggle={false}
                    enableColumnFilterModes={true}
                    enableColumnOrdering={true}
                    enableColumnActions={true}
                    enableColumnFilters={true}
                    enableSorting={true}
                    enableColumnResizing
                    columnResizeMode="onChange"
                    enablePinning
                    enableRowActions={acciones}
                    enableStickyHeader
                    initialState={{ showColumnFilters: false, columnVisibility: { id: false }, density: "compact" }}
                    positionToolbarAlertBanner="bottom"
                    localization={MRT_Localization_ES}
                    defaultColumn={{
                        maxSize: 400,
                        minSize: 40,
                    }}
                    muiTableContainerProps={{ sx: { maxWidth: "95vw", fontSize: { xs: ".7rem", md: "7rem" } } }}
                    enableEditing={false}
                    renderRowActions={({ row, table }) => (
                        <Box sx={{ display: "flex", gap: "1rem" }}>
                            <Tooltip arrow placement="left" title={<Typography sx={{ fontSize: "0.8rem" }}>Ver</Typography>}>
                                <IconButton>
                                    <VisibilityIcon onClick={() => openModal(row)} />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    )}
                    renderTopToolbarCustomActions={() => (
                        <>
                            <Typography variant="subtitle" p="2px">
                                {titulo}
                            </Typography>
                        </>
                    )}
                />
            </ThemeProvider>
        </>
    )
}

export default React.memo(TablaObservacionesPGD)